var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.759,
    height: 13.759,
    viewBox: "0 0 13.759 13.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.419,
    y1: 1,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.571,0H6.965a.984.984,0,0,0-.983.983v3.8h.9V.983A.086.086,0,0,1,6.965.9h7.606a.086.086,0,0,1,.086.086V8.589a.086.086,0,0,1-.086.086H11.246v.9h3.325a.984.984,0,0,0,.983-.983V.983A.984.984,0,0,0,14.571,0Z",
    transform: "translate(-1.795 0)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.589,6.087H.983A.984.984,0,0,0,0,7.07v7.606a.984.984,0,0,0,.983.983H8.589a.984.984,0,0,0,.983-.983V7.07A.984.984,0,0,0,8.589,6.087Zm0,8.674H.983A.086.086,0,0,1,.9,14.675V7.07a.086.086,0,0,1,.086-.086H8.589a.086.086,0,0,1,.086.086v7.606h0A.086.086,0,0,1,8.589,14.761Z",
    transform: "translate(0 -1.899)",
    fill: "#000000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.048823d3.svg";
export { ForwardRef as ReactComponent };